<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="copyright text-center p-0 m-0">
        <a href="https://agionet.cz" target="_blank"><img src="https://www.agionet.cz/images/loga/logo-agionet.png" style="width: 60px;" /></a>
      </div>
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>

</style>
